import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogTitle,
  MatDialogClose,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { ContactListComponent } from '../../contact/list/list.component';
import { ContactsRequest } from '../../api/models/contacts-request';
import { decompressFromEncodedURIComponent } from 'lz-string';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

export interface BroadcastContactsFilterDialogData {
  selectedFilter: ContactsRequest;
}

@Component({
  selector: 'app-broadcast-contacts-filter',
  template: `
    <div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
      <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
        <div fxFlex>Compose Contacts Filter</div>
        <button mat-icon-button [mat-dialog-close]="false" class="button-40">
          <mat-icon>close</mat-icon>
        </button>
      </h1>
      <mat-dialog-content class="mat-typography" fxFlex>
        <app-contacts-list
          #contactsGrid
          [readonly]="true"
          [customContactsQuery]="customContactsQuery"
          [disableUrlChanges]="true"
          fxFlex
          style="width: 100%"
        ></app-contacts-list>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-stroked-button color="primary" (click)="onSubmit()" cdkFocusInitial>Save</button>
      </mat-dialog-actions>
    </div>
  `,
  styles: [],
  standalone: true,
  imports: [
    FlexModule,
    MatDialogTitle,
    MatIconButton,
    MatDialogClose,
    MatIcon,
    MatDialogContent,
    ContactListComponent,
    MatDialogActions,
    MatButton,
  ],
})
export class BroadcastContactsFilterDialogComponent implements OnInit {
  isLoading = false;

  selectedFilter: ContactsRequest;
  customContactsQuery = '';

  @ViewChild('contactsGrid', { static: true }) contactsGrid: ContactListComponent;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<BroadcastContactsFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BroadcastContactsFilterDialogData,
  ) {}

  ngOnInit() {
    this.selectedFilter = this.data.selectedFilter;
    if (this.selectedFilter?.filterQuery) {
      this.customContactsQuery = decompressFromEncodedURIComponent(this.selectedFilter.filterQuery);
    } else {
      this.customContactsQuery = '';
    }
  }

  onSubmit() {
    this.dialogRef.close(this.contactsGrid.getDataFilter());
  }
}
